var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7251_11904",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.5001C3.58172 16.5001 0 12.9184 0 8.50012C0 4.08184 3.58172 0.500122 8 0.500122C12.4183 0.500122 16 4.08184 16 8.50012C16 12.9184 12.4183 16.5001 8 16.5001ZM1.28988 10.5001C1.10128 9.86641 1 9.1951 1 8.50012C1 7.80515 1.10128 7.13383 1.28988 6.50012H4.61581C4.54025 7.14649 4.5 7.82103 4.5 8.51095C4.5 9.19368 4.53942 9.86082 4.61346 10.5001H1.28988ZM1.67363 11.5001C2.53757 13.3187 4.16259 14.7058 6.1371 15.2495C5.52427 14.354 5.03958 13.0376 4.76124 11.5001H1.67363ZM5.77869 11.5001C5.94208 12.3401 6.16995 13.0938 6.44244 13.7216C6.72732 14.3779 7.04109 14.8507 7.33958 15.1449C7.63459 15.4357 7.85672 15.5001 8 15.5001C8.14328 15.5001 8.36541 15.4357 8.66042 15.1449C8.95891 14.8507 9.27268 14.3779 9.55756 13.7216C9.83005 13.0938 10.0579 12.3401 10.2213 11.5001H5.77869ZM11.2388 11.5001C10.9604 13.0376 10.4757 14.354 9.8629 15.2495C11.8374 14.7058 13.4624 13.3187 14.3264 11.5001H11.2388ZM14.7101 10.5001H11.3865C11.4606 9.86082 11.5 9.19368 11.5 8.51095C11.5 7.82103 11.4597 7.14649 11.3842 6.50012H14.7101C14.8987 7.13383 15 7.80515 15 8.50012C15 9.1951 14.8987 9.86641 14.7101 10.5001ZM10.3794 10.5001H5.62057C5.54249 9.86758 5.5 9.19994 5.5 8.51095C5.5 7.81476 5.54338 7.13968 5.62305 6.50012H10.377C10.4566 7.13968 10.5 7.81476 10.5 8.51095C10.5 9.19994 10.4575 9.86758 10.3794 10.5001ZM4.76458 5.50012H1.67363C2.53833 3.67989 4.16546 2.29205 6.14233 1.74929C5.52948 2.64539 5.04424 3.96291 4.76458 5.50012ZM6.44298 3.2882C6.17214 3.9145 5.94541 4.66496 5.7822 5.50012H10.2178C10.0546 4.66496 9.82786 3.9145 9.55702 3.2882C9.27186 2.62878 8.95768 2.15311 8.65867 1.85698C8.36292 1.56407 8.14128 1.50012 8 1.50012C7.85872 1.50012 7.63708 1.56407 7.34133 1.85698C7.04232 2.15311 6.72814 2.62878 6.44298 3.2882ZM11.2354 5.50012H14.3264C13.4617 3.67989 11.8345 2.29204 9.85767 1.74929C10.4705 2.64539 10.9558 3.96291 11.2354 5.50012Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7251_11904)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.500122)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeOutlined);
export default __webpack_public_path__ + "static/media/globe-outlined.509f9ad7ffbd821646dc37a40a05402d.svg";
export { ForwardRef as ReactComponent };